"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShellContext = void 0;
var useShellContext_1 = require("./useShellContext");
Object.defineProperty(exports, "useShellContext", { enumerable: true, get: function () { return __importDefault(useShellContext_1).default; } });
